import React, { Component } from "react";
import { Card, CardBody, Row, Col } from "reactstrap";
class LoaderAssessSelectorBar extends Component {
  render() {
    const style_col = {
      //   marginTop: '-1.3%',
      // marginLeft: '-1.8%',
      // marginBottom: '2%',
      padding: "0px"
    };
    const style_div = {
      backgroundColor: "#f4f8fb"
      // paddingBottom: '26px'
    };
    return (
      <Col sm="12" md="12" lg="12" xl="12" style={style_col}>
        <Card>
         
          <CardBody  style={style_div}>
            <div className="row">
              <div className="col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <div>&nbsp;</div>
                <div className="dropdown">
                  <div className="loading-animation">
                    <div className="donut-loader">
                      <div className="css-6fyzox" />
                      <div className="css-1dhe946" />
                      <div className="css-6fyzox" />
                    </div>
                  </div>
                </div>
                <div>&nbsp;</div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <div>&nbsp;</div>
                <div className="dropdown">
                  <div className="loading-animation">
                    <div className="donut-loader">
                      <div className="css-6fyzox" />
                      <div className="css-1dhe946" />
                      <div className="css-6fyzox" />
                    </div>
                  </div>
                </div>
                <div>&nbsp;</div>
              </div>
              <div className="col-sm-12 col-md-6 col-lg-2 col-xl-2">
                <div>&nbsp;</div>
                <div className="loading-animation">
                  <div className="donut-loader">
                    <div className="css-6fyzox" />
                    <div className="css-1dhe946" />
                    <div className="css-6fyzox" />
                  </div>
                </div>
                <div>&nbsp;</div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default LoaderAssessSelectorBar;



// WEBPACK FOOTER //
// ./src/components/Assessment/AssessSelectorBar/LoaderAssessSelectorBar.js